<template>
  <v-layout row>
    <v-flex xs12>
    <v-toolbar app>
    <!-- <v-btn icon><v-icon>keyboard_arrow_left</v-icon></v-btn> -->
    <v-toolbar-title>Solicitar Delivery</v-toolbar-title>
    <v-spacer></v-spacer>
     <v-btn icon to="/delivery"> 
              <v-icon>cancel</v-icon> 
            </v-btn>
  </v-toolbar>
        
        
          <div class="pt-4 pb-4 pl-4 pr-4">
            <v-card class="login-form">
              <v-card-text class="">
                <v-form v-model="valid">
                  <h2 class="headline">Solicitud de  Delivery</h2>

                  <v-text-field required :rules="required" v-model="text7" label="Dirección" type="text"></v-text-field>
                  <v-text-field required :rules="required" v-model="text8" label="Telefono" type="text"></v-text-field>
                  <v-text-field required  v-model="text9" label="Telefono" type="text"></v-text-field>
                  <v-textarea
                  v-model="text6"
                  label="Comentario"
                ></v-textarea>
                 
                  
                  
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn :disabled="!valid" block color="primary" @click="validateLogin">Enviar</v-btn>
              </v-card-actions>
              
            </v-card>
          </div>
          
        </v-flex>
  </v-layout>
</template>

<script>
  import Helpers from '../utils/helpers'
  import Server from '../utils/server'
export default {

  data () {
    return {
      clipped: false,
      currentUser: undefined,
      noData:false,
      loading: false,
      text6:"",
      text7:"",
      text8:"",
      text9:"",
      valid:false,required: [
        v => !!v || 'El campo es requerido'
      ]
    }
  },
  computed: {
    user(){
      return this.$store.getters.user;
    },
    login(){
      return this.$store.getters.login;
    }
  },
   mounted () {
     console.log(Server); 
    if(this.currentUser != undefined){  
    }else if(this.user.userName != null ){
      this.currentUser = this.user;
    }
    
  },
  methods: {
    validateLogin: function () {

        var formData = new FormData()
         formData.append('text1', this.currentUser.userName) 
         formData.append('text3', this.currentUser.pushId)
         formData.append('device', window.MobileApi.device)
         formData.append('text6', this.text6)
         formData.append('text7', this.text7)
         formData.append('text8', this.text8)
         formData.append('text9', this.text9)

         console.log(Server.createPrealerta); 
        Helpers.getJson(Server.createDeliveryRequest, 'POST', formData, (json) => {
          
        })
        this.$router.push('/delivery')
      }
  },
  name: 'App'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
